import axios from 'axios';

class SSOService {
  putSSO(payload) {
    return axios.put(`/company/sso_status`, payload);
  }
  postDomainSSO(payload) {
    return axios.post(`/company/sso_domain`, payload);
  }
  deleteDomain(domain) {
    return axios.delete(`/company/sso_domain/${domain}`);
  }
  updateDomain(id, payload) {
    return axios.put(`/company/sso_domain/${id}`, payload);
  }
  postXML(payload) {   
    return axios.post(`/company/sso_metadata`, payload, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }); 
  }
  getEmailTokenSSO() {
    return axios.get(`/company/new-sso-email-token`);
  }
  postValidateDomain(payload) {
    return axios.post(`company/sso_domain/validate`, payload);
  }
  getDataCognito() {
    return axios.get(`company/sso_config`);
  }
}

export default new SSOService();
